import * as Net from 'util/Net';

export interface SuggestedQuestion {
  question: string;
}

export interface GenerateSuggestedQuestionsResponse {
  traceId: string;
  questions: Array<SuggestedQuestion>;
}

/**
 * Generate AI-suggested questions about a folder item.
 */
export async function generateSuggestedQuestions(
  fileId: string
): Promise<GenerateSuggestedQuestionsResponse> {
  const response = await Net.postJSONPromise({
    url: '/1/api/chats/ask:generate-suggested-questions',
    data: {fileId},
  });
  return {
    traceId: response.traceId,
    questions: response.questions,
  };
}
